'use client';

import { useEffect, useMemo, useRef, type CSSProperties } from 'react';
import s from './styles.module.scss';

export type RotatingFaqDividerProps = {
    text?: string;
    background?: string;
    angleDeg?: number;
    speedPxPerSec?: number;
    className?: string;
};

export const RotatingFaqDivider = ({
    text = 'faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq - faq -',
    background = '#FF4A00',
    angleDeg = 1,
    speedPxPerSec = 60,
    className,
}: RotatingFaqDividerProps) => {
    const rootRef = useRef<HTMLDivElement | null>(null);
    const trackRef = useRef<HTMLDivElement | null>(null);

    const items = useMemo(() => Array.from({ length: 20 }).map((_, i) => ({ key: i })), []);

    useEffect(() => {
        const track = trackRef.current;
        const root = rootRef.current;
        if (!track || !root) return;

        const halfWidth = track.scrollWidth / 2;
        const durationSec = Math.max(halfWidth / Math.max(1, speedPxPerSec), 6);
        root.style.setProperty('--duration', `${durationSec}s`);
    }, [speedPxPerSec, text]);

    type StyleVars = CSSProperties & { '--bg'?: string; '--angle'?: string };
    const style: StyleVars = {
        '--bg': background,
        '--angle': `${angleDeg}deg`,
    };

    return (
        <div ref={rootRef} className={`${s.root} ${className ?? ''}`} style={style} aria-hidden>
            <div className={s.tilt}>
                <div className={s.banner}>
                    <div className={s.marquee}>
                        <div className={s.track} ref={trackRef}>
                            {items.map((it) => (
                                <span className={s.item} key={`a-${it.key}`}>
                                    {text}
                                </span>
                            ))}
                            {items.map((it) => (
                                <span className={s.item} key={`b-${it.key}`}>
                                    {text}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
